import { useState } from 'react';
import getCSRFToken from '../../utils/getCSRFToken';
// import * as Sentry from '@sentry/browser';

const request = async ({ method, url, body }) => {
  return fetch(url, {
    method,
    credentials: 'same-origin',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': getCSRFToken(),
    },
    ...body && {
      body: JSON.stringify(body),
    },
  })
    .then(async (response) => {
      const { ok, status, statusText } = response;
      const json = await response.json();
      if (ok) {
        return { response: json };
      }

      return {
        apiError: {
          status,
          message: statusText,
          detail: json,
        },
      };
    })
    .then(resp => Promise.resolve(resp))
    .catch((err) => {
      // as far as I'm aware this only happens when the call to response.json() above fails
      // this is usually because html is sent in response which shouldn't happen
      // Sentry.captureException(err);
      return { apiError: { message: 'An error occurred' } };
    });
};

export const clearCart = () => () => {
  return request({
    url: '/api/choose-your-price/clearcart/',
    method: 'POST',
  });
};

export const getSessions = () => (eventId) => {
  return request({
    url: `/api/choose-your-price/sessions/${ eventId }/`,
    method: 'GET',
  });
};

export const getShowingDetails = () => (eventId, showingId) => {
  return request({
    url: `/api/choose-your-price/event/${ eventId }/showing/${ showingId }/`,
    method: 'GET',
  });
};

export const getNonCYPShowingDetails = () => (eventId, showingId) => {
  return request({
    url: `/api/choose-your-price/non-cyp-event/${ eventId }/showing/${ showingId }/`,
    method: 'GET',
  });
};


export const purchaseTickets = () => (eventId, showingId, numTickets, chosenTicket) => {
  return request({
    method: 'POST',
    url: `/api/choose-your-price/event/${ eventId }/showing/${ showingId }/purchase/`,
    body: {
      'num_tickets': numTickets,
      'tk': chosenTicket.id,
    },
  });
};

export const deleteTickets = () => (eventId, showingId, price) => {
  return request({
    method: 'DELETE',
    url: '/api/choose-your-price/delete/',
    body: {
      'eventId': eventId,
      'showId': showingId,
      'price': price,
    },
  });
};


const useRequestStatusDecorator = () => {
  const [status, setStatus] = useState('initial');

  const withStatus = (fn) => (...args) => {
    setStatus('processing');
    return fn(...args).then(resp => {
      setStatus('complete');
      return resp;
    });
  };

  return { status, withStatus };
};

export default function useApi() {
  const { status, withStatus } = useRequestStatusDecorator();

  return {
    status,
    clearCart: withStatus(clearCart()),
    getNonCYPShowingDetails: withStatus(getNonCYPShowingDetails()),
    getSessions: withStatus(getSessions()),
    getShowingDetails: withStatus(getShowingDetails()),
    purchaseTickets: withStatus(purchaseTickets()),
    deleteTickets: withStatus(deleteTickets()),
  };
}
